// React Dependencies
import React, { useEffect, useState } from 'react';

// External Dependencies
import { connect } from 'react-redux';
import { Button, Grid, Paper, Typography, Link, Chip } from '@material-ui/core';
import LocationIcon from '@material-ui/icons/LocationOn';
import { makeStyles } from '@material-ui/core/styles';
import ReactPlayer from 'react-player';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

// Internal Dependencies
import { Status } from '../../common/constants';
import { ConvertDateToSGTime } from '../../common/util';
import Colours from '../../styles/colours';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding:  theme.spacing(2),
    margin:   'auto',
    maxWidth: '100%',
  },
  image: {
    width:  '100%',
    height: 'fit-content',
  },
  img: {
    margin:    'auto',
    display:   'block',
    maxWidth:  '100%',
    maxHeight: '100%',
  },
}));

const ScrappedPromo = ({
  pageId, content, score, link, location, brand, photos, videos, status,
  onAcceptClicked, onExpiredClicked, onRejectClicked, onVideoClicked, onRevertClicked,
  lastUpdatedBy, createdAt, updatedAt, createdPostId,
}) => {
  const [displayContent, setDisplayContent] = useState('');
  const [perPostImages, setPerPostImages] = useState([]);
  const [popUpImage, setImage] = useState('');
  const [photoIndex, setPhotoIndex] = useState(0);
  const [formattedCreatedAt, setFormattedCreatedAt] = useState(null);
  const [formattedUpdatedAt, setFormattedUpdatedAt] = useState(null);
  const classes = useStyles();
  useEffect(() => {
    setDisplayContent(content);
  }, [content]);

  useEffect(() => {
    setImage(perPostImages[photoIndex]);
  }, [photoIndex]);

  useEffect(() => {
    if (createdAt) {
      const dateToSGTime = ConvertDateToSGTime(new Date(createdAt));
      setFormattedCreatedAt(`${dateToSGTime.toLocaleString('en-SG', { weekday: 'long' })}, ${dateToSGTime.getDate()} ${dateToSGTime.toLocaleString('en-SG', { month: 'long' })} ${dateToSGTime.getFullYear()}`);
    }
    if (updatedAt) {
      const dateToSGTime = ConvertDateToSGTime(new Date(updatedAt));
      setFormattedUpdatedAt(`${dateToSGTime.toLocaleString('en-SG', { weekday: 'long' })}, ${dateToSGTime.getDate()} ${dateToSGTime.toLocaleString('en-SG', { month: 'long' })} ${dateToSGTime.getFullYear()}`);
    }
  });
  function showModal(data) {
    setPerPostImages(data);
    setImage(data[photoIndex]);
  }

  return (
    <div className={classes.root}>
      {popUpImage && (
        <Lightbox
          animationDisabled
          mainSrc={popUpImage}
          nextSrc={perPostImages.length > 1 ? perPostImages[(photoIndex + 1) % perPostImages.length] : false}
          prevSrc={perPostImages.length > 1 ? perPostImages[(photoIndex + perPostImages.length - 1) % perPostImages.length] : false}
          onCloseRequest={() => {
            setImage('');
            setPhotoIndex(0);
            setPerPostImages([]);
          }}
          onMovePrevRequest={() => {
            setPhotoIndex((photoIndex + perPostImages.length - 1) % perPostImages.length);
          }}
          onMoveNextRequest={() => {
            setPhotoIndex((photoIndex + 1) % perPostImages.length);
          }}
        />
      )}
      <Paper className={classes.paper}>
        <Grid container spacing={2} direction="row">
          <Grid item container xs={12} md={3} className={classes.image}>
            {
              (photos && photos.length > 0 && videos.length == 0)
                ? (
                  <>
                    <div style={{ position: 'relative', border: `1px solid ${Colours.LightGray}`, width: '100%', maxWidth: '280px', height: 'auto' }}>
                      <img
                        className={classes.img}
                        style={{
                          width:     'auto',
                          height:    'auto',
                          maxHeight: 280,
                        }}
                        alt="photo"
                        src={photos[0]}
                        onClick={() => showModal(photos)}
                      />
                      <span
                        className="badge"
                        style={{
                          position:     'absolute',
                          background:   '#00000055',
                          color:        '#FFFFFF',
                          borderRadius: 0,
                          width:        '100%',
                          fontSize:     16,
                          padding:      '8px 0',
                          bottom:       0,
                          left:         0,
                        }}
                      >
                        { photos.length > 1 ? `${photos.length} images` : `${photos.length} image` }
                      </span>
                    </div>
                  </>
                )
                : (videos && videos.length > 0)
                  ? (
                    <Grid item xs={12} direction="column" justify="center" container className={classes.image}>
                      <Typography variant="caption" style={{ marginTop: 0, paddingTop: 0, alignSelf: 'center' }}>Video</Typography>
                      <ReactPlayer
                        url={videos[0]}
                        style={{ zIndex: 1, position: 'relative', top: 0, left: 0, right: 0 }}
                        width={80}
                        height={80}
                        className={classes.img}
                        playing={false}
                        light
                        volume={0}
                        onClick={() => onVideoClicked(videos[0])}
                      />
                    </Grid>
                  )
                  : <Typography>No photo</Typography>
            }
            {/* <img className={classes.img}
              style={{ backgroundsize: 'contain' }}
              alt="photo"
              src="http://d1aq8vpj94zs31.cloudfront.net/2040ad87-624c-4a04-a604-bf73c748c6c1_images.jpg" /> */}
          </Grid>

          <Grid item xs={12} md={9} sm container>
            <Grid item xs container direction="column" spacing={1}>
              {
                status !== Status.Pending && (
                  <Grid item xs>
                    <Chip label={status} color={status === Status.Rejected ? 'secondary' : 'primary'} />
                    <span style={{
                      paddingLeft:   '10px',
                      paddingRight:  '10px',
                      letterSpacing: '0.5px',
                    }}
                    >
                      Updated By :
                      {' '}
                      {`${lastUpdatedBy} (${formattedUpdatedAt})` || '-'}
                    </span>
                  </Grid>

                )
              }
              <Grid item xs>
                <Typography style={{ fontSize: 18 }} color={score && score > 0.6 ? 'secondary' : 'primary'}>
                  Score =
                  {' '}
                  {score || 'null'}
                </Typography>
              </Grid>
              <Grid item xs>
                <div
                  title={content}
                  style={{
                    maxWidth: '850px',
                  }}
                >
                  <Typography
                    style={{
                      wordWrap: 'break-word',
                      fontSize: 18,
                    }}
                  >
                    {displayContent || '<No content>'}

                  </Typography>
                </div>
              </Grid>
              <Grid item xs direction="row" container className="mt-4">
                <Grid item xs={12} sm={12} lg={7}>
                  {/* <Typography style={{ color: '#888' }}>Post Date: 28 May 2020</Typography> */}
                  <Typography
                    style={{
                      color:    '#888',
                      fontSize: 18,
                    }}
                  >
                    Brand / Outlet Name:
                    {' '}
                    {<Link style={{ wordBreak: 'break-word' }} href={`page/${pageId}/posts`} target="_blank">{brand}</Link> || 'Unspecified'}
                  </Typography>
                  <hr />
                  <Grid item container direction="row">
                    <LocationIcon />
                    <Typography style={{ wordBreak: 'break-word', color: '#888' }}>{`Location: ${(location && location[0]) ? location[0].mallName : 'Unspecified'}`}</Typography>
                  </Grid>
                  <hr />
                  <Typography style={{ color: '#888' }}>
                    Source:
                    {' '}
                    {
                      link
                        ? <Link style={{ wordBreak: 'break-word' }} href={link} target="_blank">{link}</Link>
                        : ' -'
                    }
                  </Typography>
                  <Typography style={{ color: '#888' }}>
                    Scrapped at:
                    {' '}
                    { formattedCreatedAt || ' -' }
                  </Typography>
                  {
                    createdPostId
                    && (
                      <Typography style={{ color: '#888' }}>
                        Converted post:
                        {' '}
                        <Link href={`/admin/page/${pageId}/post/${createdPostId}`} target="_blank">{`${window.location.origin.toString()}/admin/page/${pageId}/post/${createdPostId}`}</Link>
                      </Typography>
                    )

                  }
                </Grid>

                <Grid item xs={12} sm={12} lg={5} container justify="space-evenly" alignItems="center" direction="row" style={{ marginTop: 15 }}>
                  <Button disabled={status !== Status.Pending} onClick={() => onRejectClicked()} variant="contained" color="secondary">Reject</Button>
                  <Button disabled={status !== Status.Pending} onClick={() => onExpiredClicked()} variant="contained" color="default">Expired</Button>
                  <Button disabled={status !== Status.Pending} onClick={() => onAcceptClicked()} variant="contained" color="primary">Accept</Button>
                  {
                    // Only status that was Expired or Rejected can be reverted back to Pending status
                    [Status.Expired, Status.Rejected].includes(status) && (
                      <Button onClick={() => onRevertClicked()} variant="contained" color="secondary">Revert</Button>
                    )
                  }
                </Grid>
              </Grid>
            </Grid>
          </Grid>

        </Grid>
      </Paper>

    </div>
  );
};

ScrappedPromo.postTypes = {
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, null)(ScrappedPromo);
